<template>
    <div class="ah-page accounting-yearly-management">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>年度會計總管理</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 20px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-body" style="padding: 20px 40px">
                        <ah-sticky-el-table-header>
                            <el-table v-loading="isLoading" :data="datas" ref="table" empty-text="沒有資料" style="width: 100%; margin-bottom: 30px;">
                                <el-table-column prop="year" label="年度" width="80">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.year - 1911 }} 年</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="status" label="狀態" width="130">
                                    <template slot-scope="scope">
                                        <AccountYearStatusLabel :value="scope.row.status" :locked="scope.row.isLocked" />
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column prop="status" label="" min-width="300">
                                    <template slot-scope="scope">
                                        <AccAnnualStatusSteps
                                            :status="scope.row.status + 1"
                                            :settlement-operator="scope.row.lastSettlementOperatorName"
                                            :settlement-date="scope.row.lastSettlementBelongDate"
                                            :close-operator="scope.row.lastClosedOperatorName"
                                            :close-date="getDateText(scope.row.lastClosedOperationTime)"
                                        />
                                    </template>
                                </el-table-column> -->
                                <el-table-column prop="excludedVoucherCount" min-width="130px">
                                    <template slot="header">
                                        <div>未列入報表傳票<ah-tip>報表後鎖定新增的傳票，不列入報表計算。</ah-tip></div>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button v-if="scope.row.excludedVoucherCount" type="text" @click="onGoToNonIncludedVoucherListPage(scope.row.year)">
                                            <i class="el-icon-warning" style="color: #ffba00" />
                                            <span style="text-decoration: underline;">{{ scope.row.excludedVoucherCount }} 張</span>
                                        </el-button>
                                        <span v-else style="opacity: 0.6;">(無)</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="accounting-report" label="會計報表" min-width="300px">
                                    <template slot-scope="scope">
                                        <el-button-group style="margin-right: 10px;">
                                            <el-button size="small" @click="onAccountingBalanceSheetDialogOpen(scope.row.year)">資產負債表</el-button>
                                            <el-button size="small" @click="onAccountingStatementDialogOpen(scope.row.year)">綜合損益表</el-button>
                                        </el-button-group>
                                        <el-button size="small" @click="onOtherSheetsDialogOpen(scope.row.year)" icon="el-icon-more-outline">全部</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="settlement" label="功能" width="105">
                                    <template slot-scope="scope">
                                        <template>
                                            <template v-if="!isAccountingClosed(scope.row)">
                                                <el-button v-if="scope.row.status === 0" size="small" @click="onForwardYear(scope.row.year)" :disabled="isForwardYearChecking || !scope.row.isYearOpen">
                                                    結算
                                                </el-button>
                                                <el-dropdown
                                                    v-if="scope.row.status === 1"
                                                    size="small"
                                                    split-button
                                                    @click="onForwardYear(scope.row.year)"
                                                    @command="onReforwardCommand"
                                                    :disabled="isForwardYearChecking"
                                                >
                                                    <span>結算</span>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item :command="{ type: 'clear', year: scope.row.year }">清除結算</el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </template>
                                            <template v-else>
                                                <el-button size="small" disabled>結算</el-button>
                                            </template>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="accounting-locked" width="117">
                                    <template slot="header">
                                        <!-- <div>報表鎖定<ah-tip>禁止編輯現有傳票、新產生的傳票將不被列入計算。</ah-tip></div> -->
                                    </template>
                                    <template slot-scope="scope">
                                        <!-- <template v-if="!scope.row.isLocked">
                                            <span class="lock-status">
                                                <i class="el-icon-unlock"> 未鎖定</i>
                                            </span>
                                        </template>
                                        <template v-else>
                                            <el-tooltip content="禁止編輯現有傳票、新產生的傳票將不被列入報表" placement="top">
                                                <span class="lock-status locked">
                                                    <i class="el-icon-lock"> 已鎖定</i>
                                                </span>
                                            </el-tooltip>
                                        </template> -->
                                        <template v-if="!isAccountingClosed(scope.row)">
                                            <el-button v-if="!scope.row.isLocked" type="primary" size="mini" @click="onConfirmDialogOpen('lock', scope.row)" icon="el-icon-lock">鎖定報表</el-button>
                                            <el-button v-else size="small" @click="onConfirmDialogOpen('unlock', scope.row)" icon="el-icon-unlock">解除鎖定</el-button>
                                        </template>
                                        <template v-else>
                                            <el-button size="small" disabled icon="el-icon-unlock">解除鎖定</el-button>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="closing" width="125">
                                    <!-- <template slot="header">關帳 <ah-tip>所有人員不可再針對關帳年度進行任何帳務變動。</ah-tip></template> -->
                                    <template slot-scope="scope">
                                        <template v-if="scope.row.status >= 1 && scope.row.isLocked">
                                            <el-button
                                                v-if="!isAccountingClosed(scope.row)"
                                                size="small"
                                                type="success"
                                                @click="onConfirmDialogOpen('close', scope.row)"
                                                icon="el-icon-check"
                                            >關帳</el-button>
                                            <el-button
                                                v-else
                                                size="small"
                                                @click="onConfirmDialogOpen('reopen', scope.row)"
                                                icon="el-icon-refresh-right"
                                            >解除關帳</el-button>
                                        </template>
                                        <template v-else>
                                            <el-tooltip content="請先完成「結算」並「鎖定報表」後再進行關帳" placement="top">
                                                <el-button size="small" disabled icon="el-icon-check">關帳</el-button>
                                            </el-tooltip>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="record" label="紀錄" align="center" width="70">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="onOperationRecordDialogOpen(scope.row)">檢視</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </ah-sticky-el-table-header>
                    </div>
                </div>
            </div>
        </div>
        <OperationRecordDialog :visible="operationRecordDialog.visible" :year="operationRecordDialog.year" :id="confirmDialog.id" @close="onOperationRecordDialogClose" />
        <ConfirmDialog :visible="confirmDialog.visible" :purpose="confirmDialog.purpose" :id="confirmDialog.id" :year="confirmDialog.year" @close="onConfirmDialogClose" />
        <AccountingStatementDialog :visible="accountingStatementDialog.visible" :year="accountingStatementDialog.year" @close="onAccountingStatementDialogClose" />
        <AccountingBalanceSheetDialog :visible="accountingBalanceSheetDialog.visible" :year="accountingBalanceSheetDialog.year" @close="onAccountingBalanceSheetDialogClose" />
        <OtherSheetsDialog
            :visible="otherSheetsDialog.visible"
            :year="otherSheetsDialog.year"
            @onViewBalanceSheet="onAccountingBalanceSheetDialogOpen"
            @onViewStatement="onAccountingStatementDialogOpen"
            @close="onOtherSheetsDialogClose"
        />
    </div>
</template>

<script>
import moment from 'moment';
import ahStickyElTableHeader from '@/components/ui/ahStickyElTableHeader.vue';
import OperationRecordDialog from '@/components/dashboard/Accounting/AccountingYearlyManagement/OperationRecordDialog.vue';
import ConfirmDialog from '@/components/dashboard/Accounting/AccountingYearlyManagement/ConfirmDialog.vue';
import AccountingStatementDialog from '@/components/dashboard/Accounting/AccountingYearlyManagement/AccountingStatementDialog.vue';
import AccountingBalanceSheetDialog from '@/components/dashboard/Accounting/AccountingYearlyManagement/AccountingBalanceSheetDialog.vue';
import OtherSheetsDialog from '@/components/dashboard/Accounting/AccountingYearlyManagement/OtherSheetsDialog.vue';
import AccountYearStatusLabel from './AccountYearStatusLabel.vue';

export default {
    name: 'AccountingYearlyManagement',
    components: {
        // AccAnnualStatusSteps,
        ahStickyElTableHeader,
        OperationRecordDialog,
        ConfirmDialog,
        AccountingStatementDialog,
        AccountingBalanceSheetDialog,
        OtherSheetsDialog,
        AccountYearStatusLabel,
    },
    data() {
        return {
            selectedItems: [],
            isLoading: false,
            isForwardYearChecking: false,
            datas: [],
            operationRecordDialog: { visible: false, year: null },
            confirmDialog: { visible: false, purpose: null, year: null },
            accountingStatementDialog: { visible: false, year: null },
            accountingBalanceSheetDialog: { visible: false, year: null },
            otherSheetsDialog: { visible: false, year: null },
        };
    },
    mounted() {
        this.updateData();
    },
    methods: {
        async updateData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'AnnualAccountingTask/GetList',
                    method: 'GET',
                });
                this.datas = resp.data.items;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        isAccountingClosed(row) {
            return row.status === 2;
        },
        getDateText(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD');
        },
        getTimeText(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD HH:mm');
        },

        onOperationRecordDialogOpen({ year, id }) {
            this.operationRecordDialog.year = year;
            this.confirmDialog.id = id;
            this.operationRecordDialog.visible = true;
        },
        onOperationRecordDialogClose() {
            this.operationRecordDialog.visible = false;
            this.operationRecordDialog.year = null;
        },
        onConfirmDialogOpen(purpose, { year, id }) {
            this.confirmDialog.purpose = purpose;
            this.confirmDialog.year = year;
            this.confirmDialog.id = id;
            this.confirmDialog.visible = true;
        },
        onConfirmDialogClose(refresh) {
            this.confirmDialog.visible = false;
            this.confirmDialog.purpose = null;
            this.confirmDialog.year = null;
            if (refresh) this.updateData();
        },
        onAccountingStatementDialogOpen(year) {
            this.accountingStatementDialog.year = year;
            this.accountingStatementDialog.visible = true;
        },
        onAccountingStatementDialogClose() {
            this.accountingStatementDialog.visible = false;
            this.accountingStatementDialog.year = null;
        },
        onAccountingBalanceSheetDialogOpen(year) {
            this.accountingBalanceSheetDialog.year = year;
            this.accountingBalanceSheetDialog.visible = true;
        },
        onAccountingBalanceSheetDialogClose() {
            this.accountingBalanceSheetDialog.visible = false;
            this.accountingBalanceSheetDialog.year = null;
        },
        onOtherSheetsDialogOpen(year) {
            this.otherSheetsDialog.year = year;
            this.otherSheetsDialog.visible = true;
        },
        onOtherSheetsDialogClose() {
            this.otherSheetsDialog.visible = false;
            this.otherSheetsDialog.year = null;
        },

        onGoToNonIncludedVoucherListPage(year) {
            this.$router.push({
                name: 'accounting-yearly-excluded-voucher-list',
                params: { year },
            });
        },
        async onForwardYear(year) {
            try {
                this.isForwardYearChecking = true;

                // 取得該年結算傳票
                const START_OF_QUERY_YEAR = moment().year(year).startOf('year').format('x');
                const END_OF_QUERY_YEAR = moment().year(year).endOf('year').format('x');
                const QUERY_TW_YEAR = year - 1911;
                const resp1 = await this.$api({
                    url: 'AccountingSummaryPage/QueryVouchers',
                    method: 'GET',
                    params: {
                        StartDateStart: START_OF_QUERY_YEAR,
                        StartDateEnd: END_OF_QUERY_YEAR,
                        TransactionType: 13, // 結算傳票
                        PageSize: 25,
                        PageNum: 1,
                    },
                });
                const HAS_FORWARDED_THIS_YEAR = !!resp1.data.items.length;

                // 取得次年是否已鎖定
                const nextYearData = this.datas.find((d) => d.year === year + 1);
                const IS_LOCKED_NEXT_YEAR = nextYearData?.isLocked;

                // Confrim Msg
                this.isForwardYearChecking = false;
                const CONFIRM_TITLE = `確定要結算 ${QUERY_TW_YEAR} 年度嗎？`;
                let CONFIRM_MSG = '';
                if (HAS_FORWARDED_THIS_YEAR && IS_LOCKED_NEXT_YEAR) {
                    CONFIRM_MSG = `此動作將重新產生並覆蓋現有的 ${QUERY_TW_YEAR} 年結帳傳票。因 ${QUERY_TW_YEAR + 1} 年已鎖定，將不再產生該年開帳傳票，請手動處理。`;
                }
                if (HAS_FORWARDED_THIS_YEAR && !IS_LOCKED_NEXT_YEAR) {
                    CONFIRM_MSG = `此動作將重新產生並覆蓋現有的 ${QUERY_TW_YEAR} 年結帳傳票、及 ${QUERY_TW_YEAR + 1} 年的開帳傳票。`;
                }
                if (!HAS_FORWARDED_THIS_YEAR && IS_LOCKED_NEXT_YEAR) {
                    CONFIRM_MSG = `因 ${QUERY_TW_YEAR + 1} 年已鎖定，將不再產生該年開帳傳票，請手動處理。`;
                }

                await this.$confirm(CONFIRM_MSG, CONFIRM_TITLE, {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoading = true;
                await this.$api({
                    url: '/AccountingSummaryPage/YearVoucher',
                    method: 'POST',
                    data: {
                        year,
                        settlementBelongDate: +moment().startOf('day').format('x'),
                    },
                });
                this.$message.success(`${QUERY_TW_YEAR} 年結算完成！`);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
                this.updateData();
            }
        },
        async onReforwardCommand({ type, year }) {
            if (type === 'clear') {
                await this.$confirm(`此動作將刪除 ${year} 年的結帳傳票。`, '確定要清除結算？', {
                    confirmButtonText: '確定清除',
                    cancelButtonText: '取消',
                });

                try {
                    this.isLoading = true;
                    await this.$api({
                        url: '/AccountingSummaryPage/CancelYearVoucher',
                        method: 'POST',
                        data: { year },
                    });
                    this.$message.success(`已清除結算 ${year - 1911} 年。`);
                } catch (e) {
                    console.log(e);
                } finally {
                    this.isLoading = false;
                    this.updateData();
                }
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting-yearly-management {
    .lock-status {
        display: inline-block;
        white-space: nowrap;
        font-size: 12px;
        background-color: #eee;
        padding: 3px 10px;
        border-radius: 10px;
        margin-right: 8px;
        cursor: default;

        &.locked {
            color: #0baa1b !important;
            background-color: #def5d6;
        }
    }
    .primary {
        color: $main-color;
    }
    .accounting-report {
        display: flex;
        flex-direction: column;
        line-height: 100%;
        > * {
            &:first-child {
                margin-right: 10px;
            }
            > * {
                font-weight: bold;
            }
        }

        .el-button--small {
            padding: 5px 15px;
        }
    }

    .acc-year-steps {

        .el-step__icon {
            background-color: transparent;
        }

        .el-step__title {
            font-size: 14px;
            line-height: 26px;
        }
        .step-description {
            font-size: 10px;
            line-height: 13px;
            margin-top: 4px;
        }
    }
}
</style>
